import SwiperBox from './SwiperBox'
import SwiperItem from './SwiperItem'

export {
    SwiperBox, SwiperItem
}
